var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"two-line":""}},[_c('v-list-item-content',[_c('v-list-item-subtitle',{class:_vm.labelClass},[_vm._v(_vm._s(_vm.label))]),_c('v-list-item-title',{staticClass:"wrap-text"},[_vm._t("default",function(){return [_c('label',{class:_vm.valueClass,domProps:{"innerHTML":_vm._s(_vm.value)}})]})],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }